/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FormInitQueue
 */
export interface FormInitQueue {
    /**
     * 
     * @type {boolean}
     * @memberof FormInitQueue
     */
    asynchronously?: boolean;
}

export function FormInitQueueFromJSON(json: any): FormInitQueue {
    return FormInitQueueFromJSONTyped(json, false);
}

export function FormInitQueueFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormInitQueue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asynchronously': !exists(json, 'asynchronously') ? undefined : json['asynchronously'],
    };
}

export function FormInitQueueToJSON(value?: FormInitQueue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asynchronously': value.asynchronously,
    };
}


